import useStore, { selectCountryTheme } from '@/hooks/client/useStore';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';

const css = {
  btn: (color) => ({
    minHeight: '56px',
    backgroundColor: color,
    width: '100%',
    fontSize: '1.25rem',
    fontWeight: '800',
    borderRadius: 3,
  }),
};

/**
 * Button used in search, find batch code, quick view, etc...
 * @returns {JSX.Element}
 */
const PrimaryButton = ({ text, onClick, sx = {}, ...props }) => {
  const countryTheme = useStore(selectCountryTheme);
  return (
    <Button
      {...props}
      variant="contained"
      onClick={onClick}
      aria-label={text}
      sx={{ ...css.btn(countryTheme.accentColor), ...sx }}
    >
      {text}
    </Button>
  );
};

PrimaryButton.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  sx: PropTypes.string,
};

export default PrimaryButton;
